import { ExternalLink } from "lucide-react";

const LOGO_WHITE = "/sbgwc-logo-white.png";

export default function SiteFooter({ light = false }) {
  return (
    <footer className={`site-footer ${light ? "light" : ""}`} data-testid="site-footer">
      <div className="sf-inner">
        <a href="https://www.southernblackgirls.org" target="_blank" rel="noopener noreferrer" className="sf-logo" data-testid="footer-logo-link">
          <img src={LOGO_WHITE} alt="Southern Black Girls and Women's Consortium" />
        </a>
        <p className="sf-desc" data-testid="footer-description">
          Southern Black Girls and Women's Consortium channels philanthropic resources to Black girls, women, and femme identifying communities across 13 Southern states. Since 2017, we have invested more than $11.4 million in 250+ organizations and awarded 1,000+ #BlackGirlJoyChallenge grants.
        </p>
        <a href="https://www.southernblackgirls.org" target="_blank" rel="noopener noreferrer" className="sf-link" data-testid="footer-website-link">
          www.southernblackgirls.org <ExternalLink size={13} />
        </a>
        <div className="sf-meta">Copyright © {new Date().getFullYear()}. Southern Black Girls and Women's Consortium. All Rights Reserved.</div>
      </div>
    </footer>
  );
}
